<template>
  <div class="users container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"/>
    <!--<div class="level">-->
    <!--  <div class="level-left"><h1 class="title page-title">{{fullName}}</h1></div>-->
      
    <!--</div>-->

    <div class="card-container">
      <div class="columns">
          <div class="column is-one-half">
            <h1 class="title page-title">{{results.nameFirst}} {{results.nameLast}}</h1>
          </div>
          <div class="column is-one-half">
            <h1 class="title page-title">Billing Address</h1>
          </div>
      </div>
      <div class="columns">
        <div class="column is-one-half">
          <b-field label="First Name" :type="!results.nameFirst && !isLoading ? 'is-danger': ''">
          <b-input v-model="results.nameFirst"/>
          </b-field>
          <b-field label="Last Name" :type="!results.nameLast && !isLoading ? 'is-danger': ''">
          <b-input v-model="results.nameLast"/>
          </b-field>
          <b-field label="Username/Email" :type="!results.email && !isLoading ? 'is-danger': ''">
          <b-input type="email" v-model="results.email"/>
          </b-field>
          <b-field label="Phone">
          <b-input v-model="results.phoneNumber"/>
          </b-field>
        </div>
        <div class="column is-one-half">
          <b-field autocomplete="off" label="Address Line 1" :type="!results.billingAddressLine1 && !isLoading ? 'is-danger': ''">
          <b-input v-model="results.billingAddressLine1"/>
          </b-field>
          <b-field label="Address Line 2">
          <b-input v-model="results.billingAddressLine2"/>
          </b-field>
          <b-field label="Address City" :type="!results.billingAddressCity && !isLoading ? 'is-danger': ''">
          <b-input v-model="results.billingAddressCity" />
          </b-field>
          <b-field label="Address State" :type="!results.billingAddressState && !isLoading ? 'is-danger': ''">
          <b-input v-model="results.billingAddressState"/>
          </b-field>
          <b-field label="Address Zip" :type="!results.billingAddressZip && !isLoading ? 'is-danger': ''">
          <b-input v-model="results.billingAddressZip"/>
          </b-field>
          <b-field label="Address Country">
          <b-input v-model="results.billingAddressCountry"/>
          </b-field>
        </div>
      </div>
      <div class="userfooter">
        <p v-if="!cantUpdate && !requireAddress" class="warningText">Your changes will not be applied until you hit the "Update" button.</p>
        <p v-if="requireAddress && !isLoading" class="warningText">Please enter all required fields</p>
        <div class="buttonInteraction">
          <div class="flexChild">
            <button @click="update()" :style="{ 'background-color': buttonColor(cantUpdate) }" type="email" class="button is-primary ">Update</button>
          </div>
            <div class="flexChild">
            <router-link class="flexChild" :to="{ name: 'changePassword', params: {userID: results.__kptID, recID: recID}}">
              <button class="button is-primary">Change Password</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- SHIPPING ADDRESSES -->
    <div class="card-container">
      <div class="level">
        <div class="level-left">
          <h1 class="title page-title">Shipping Addresses on File</h1>
        </div>
      </div>
      <p v-if="shippingAddresses.length" class="subHead">These are all the shipping addresses we have on file.</p>
      <p v-else class="subHead">You have no shipping adddresses on file</p>
      <div class="newccbutton">
        <button @click="cardModal(true, false, '', {} )" class="button is-primary">New Address</button>
      </div>
      <b-table :data="shippingAddresses">
        <template slot-scope="props">

          <b-table-column field="name" label="Company or Name">
            {{ props.row.name}}
          </b-table-column>   

          <b-table-column field="shippingLine1" label="Line 1">
            {{ props.row.shippingLine1}}
          </b-table-column>   
      
          <b-table-column field="shippingLine2" label="Line 2">
            {{ props.row.shippingLine2}}
          </b-table-column>   

          <b-table-column field="shippingCity" label="City">
            {{ props.row.shippingCity}}
          </b-table-column>   

          <b-table-column field="shippingState" label="State">
            {{ props.row.shippingState}}
          </b-table-column>   

          <b-table-column field="shippingZip" label="Zip">
            {{ props.row.shippingZip}}
          </b-table-column>   

          <b-table-column field="shippingCountry" label="Country">
            {{ props.row.shippingCountry}}
          </b-table-column>   
          
          <b-table-column field="isDefault" label="" numeric>
            <div class="buttons buttonColumn">
              <b-button @click="cardModal(false, true, props.row.__kptID, props.row)" class="button is-primary">Update</b-button>
              <b-button @click="markAddressDefault(props.row.__kptID)" :style="{ 'background-color': props.row.isDefault ? '' : 'grey' }" class="button is-primary ">{{props.row.isDefault ? 'Default' : 'Make Default'}}</b-button>
              <button @click="deactivateAddress(props.row.__kptID)" class="button disabled "></button>
            </div>          
          </b-table-column>
          
        </template>
      </b-table>
    </div>
    
    <!-- CREDIT CARD INFO -->
    <div class="card-container">
      <div class="level">
        <div class="level-left">
          <h1 class="title page-title">Credit Card Info</h1>
        </div>
      </div>
      <p v-if="cc.length" class="subHead">These are all the credit cards we have on file.</p>
      <p v-else class="subHead">You have no credit cards on file</p>
      <div class="newccbutton">
        <button @click="addNewCC()" class="button is-primary">New Credit Card</button>
      </div>
      <b-table :data="cc">
        <template slot-scope="props">

          <b-table-column field="sqCardBrand" label="Brand">
            {{ props.row.sqCardBrand}}
          </b-table-column>   
      
          <b-table-column field="sqCardLast4" label="Last 4">
            {{ props.row.sqCardLast4}}
          </b-table-column>        
          
          <b-table-column field="sqCardExp" label="Expiry">
            {{ props.row.sqCardExp }}
          </b-table-column> 
          
          <b-table-column field="isDefault" label="" numeric>
            <div class="buttons buttonColumn">
              <div class="flex">
                <button @click="markccDefault(props.row.__kptID)" :style="{ 'background-color': props.row.isDefault ? '' : 'grey' }" class="button is-primary ">{{props.row.isDefault ? 'Default' : 'Make Default'}}</button>
                <button @click="deactivateCard(props.row.__kptID)" class="button disabled "></button>
              </div>
            </div>
          </b-table-column>

          
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import addressModal from '@/components/AddressModal'
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'
import { mapMutations, mapState } from 'vuex'
import axios from "axios";
// import { userInfo } from 'os';

export default {
  components: {
    'addressModal': addressModal
  },
  name: 'userInfoPage',
  data () {
    return {
      results: {},
      recID: this.$route.params.recID,
      isLoading: false,
      isFullPage: false,
      originalObject: {},
      cc: [],
      shippingAddresses: [],
    }
  },

  mounted () {
    this.loadData();  
    this.loadCCData();  
    this.loadShippingData();
  },


  computed: {
    fullName: function(){
      if(this.results.nameFirst){
        return `${this.results.nameFirst} ${this.results.nameLast}`
      }
      else{
        return ""
      }
    },

    cantUpdate: function() {
      if (
        this.originalObject.nameFirst == this.results.nameFirst &&
        this.originalObject.nameLast == this.results.nameLast &&
        this.originalObject.email == this.results.email &&
        this.originalObject.phoneNumber == this.results.phoneNumber &&    
        this.originalObject.billingAddressLine1 == this.results.billingAddressLine1 &&
        this.originalObject.billingAddressLine2 == this.results.billingAddressLine2 &&
        this.originalObject.billingAddressCity == this.results.billingAddressCity &&
        this.originalObject.billingAddressState == this.results.billingAddressState &&
        this.originalObject.billingAddressZip == this.results.billingAddressZip &&
        this.originalObject.billingAddressCountry == this.results.billingAddressCountry
      ) {
          return true
      }
      else{
          return false
      }
    },

    requireAddress: function() {
      if (
        !this.results.nameFirst ||
        !this.results.nameLast ||
        !this.results.email ||
        !this.results.billingAddressLine1 ||
        !this.results.billingAddressCity ||
        !this.results.billingAddressState ||
        !this.results.billingAddressZip
      ) {
          return true
      }
      else{
          return false
      }
    },

    ...mapState(['userInfo']),

  },

  methods:{
    loadData: async function(){
        var self = this
        // console.log(this.userInfo)
        this.isLoading = true
        const query = `{
            "query":[
                {"__kptID": "${self.userInfo.userID}"}
            ]
        }`
        const result = await userAPI.find(query)
        if(result.messages[0].code !== "0"){
          this.isLoading = false
          this.$toast.open({
            duration: 4000,
            message: result.messages[0].message,
            position: 'is-bottom',
            type: 'is-danger'
          })
          return
        }  
        this.results = result.response.data[0].fieldData
        if (this.results.includeOnMap == 1) {
          this.results.includeOnMap = true
        }
        this.isLoading = false
        this.originalObject = {...this.results}
    },
    
    update: async function(){
      this.isLoading = true
      var self = this
      if(this.cantUpdate){
          self.$root.$children[0].$refs.toast.error("Nothing to update", "Error")
          return
      }

      if(this.requireAddress){
          self.$root.$children[0].$refs.toast.error("Please enter required fields", "Error")
          return
      }

      if (this.results.includeOnMap == true) {
        var includeOnMap = 1
      }
      else {
        var includeOnMap = 0
      }
      this.isLoading = true
      var fieldData = `{
        "fieldData" : {
          "nameFirst" : "${this.results.nameFirst}",
          "nameLast"  : "${this.results.nameLast}",
          "email"  : "${this.results.email}",
          "phoneNumber"     : "${this.results.phoneNumber}",
          "billingAddressLine1"     : "${this.results.billingAddressLine1}",
          "billingAddressLine2"     : "${this.results.billingAddressLine2}",
          "billingAddressCity"     : "${this.results.billingAddressCity}",
          "billingAddressState"     : "${this.results.billingAddressState}",
          "billingAddressZip"     : "${this.results.billingAddressZip}",
          "billingAddressCountry"     : "${this.results.billingAddressCountry}",
          "includeOnMap"     : "${includeOnMap}"
        }
      }`
      
      const response = await userAPI.updateRecord(fieldData, this.recID)
      console.log(response)
      if(response.messages[0].code == "0"){
        this.isLoading = false
        this.originalObject = {...this.results}
        self.$root.$children[0].$refs.toast.success("User Info Updated!", "Success")
        return
      } 
      else{
        this.isLoading = false
        self.$root.$children[0].$refs.toast.error("Could not update", "Error")
      }
      // this.results = result.response.data[0].fieldData
      this.isLoading = false

    },

    buttonColor: function(param){
      if(param == true){
        return 'grey'
      }else{
        return ''
      }
    },

    loadCCData: async function(){
      try{
        //load tasks
        var self = this;
        var query = {
          query: 
          [
            { 
              _kftWholesalerID : this.userInfo.userID ,
              isDeactivated : "="
            }
          ]
        }
        this.recordID = this.$route.params.id
        
        await axios.post (`proxy.php?/layouts/credit-card/_find`, query)
          .then(response=>{
            var result = response.data.response
            result.data.forEach( record => {
              record.fieldData.isDefault = record.fieldData.isDefault == 1 ? true : false
              this.cc.push(record.fieldData)
            })
        })
      }catch(e){
        // this.$root.$children[0].$refs.toast.error(e, "Error")
        console.log(e)
      }
    },

    loadShippingData: async function(){
      try{
        //load tasks
        this.shippingAddresses = []
        var self = this;
        var query = {
          query: 
          [
            { 
              _kftWholesalerID : this.userInfo.userID,
              isDeactivated: "="
            }
          ]
        }
        this.recordID = this.$route.params.id
        
        await axios.post (`proxy.php?/layouts/wholesale-shipping/_find`, query)
          .then(response=>{
            var result = response.data.response
            result.data.forEach( record => {
              record.fieldData.isDefault = record.fieldData.isDefault == 1 ? true : false
              this.shippingAddresses.push(record.fieldData)
            }
          )
        })

      }catch(e){
        // this.$root.$children[0].$refs.toast.error(e, "Error")
        console.log(e)
      }
    },

    async markccDefault(ccID){

      //update in FM
      var scriptParameters = {
        wholesalerID: this.userInfo.userID,
        creditCardID: ccID,
      }

      try{
        //update fm
        const result = await sharedAPI.runScript("Wholesale - Web Log - Set Default Card", JSON.stringify(scriptParameters))
        var resultJSON = JSON.parse(result.response.scriptResult)
        if (resultJSON.code != 0){
          throw resultJSON.errorMessage
        }

        //mark all credit cards are false
        this.cc.forEach(card => {
          card.isDefault = false
        })

        //find index of cc card to make default
        var cardIndex = this.cc.findIndex( card => card.__kptID == ccID)
        this.cc[cardIndex].isDefault = true

      }catch(e){
        console.log(e)
        this.$root.$children[0].$refs.toast.error(e, "Error")
      }
    },

    async deactivateCard(ccID){
      var self = this
      //update in FM
      var scriptParameters = {
        wholesalerID: this.userInfo.userID,
        creditCardID: ccID,
      }

      try{
        //update fm
        self.isLoading = true
        const result = await sharedAPI.runScript("Wholesale - Web Log - Deactivate Card", JSON.stringify(scriptParameters))
        var resultJSON = JSON.parse(result.response.scriptResult)
        if (resultJSON.code != 0){
          throw resultJSON.errorMessage
        }
        self.cc = []
        const result2 = await self.loadCCData()
        self.isLoading = false
        self.$root.$children[0].$refs.toast.success("This card has been removed from your profile.", "Card Removed!")
      }catch(e){
        self.isLoading = false
        console.log(e)
        this.$root.$children[0].$refs.toast.error(e, "Error")
      }
    },

    async deactivateAddress(shippingID){
      var self = this
      //update in FM
      var scriptParameters = {
        wholesalerID: this.userInfo.userID,
        shippingID: shippingID,
      }

      try{
        //update fm
        self.isLoading = true
        const result = await sharedAPI.runScript("Wholesale - Web Log - Deactivate Shipping Address", JSON.stringify(scriptParameters))
        var resultJSON = JSON.parse(result.response.scriptResult)
        if (resultJSON.code != 0){
          throw resultJSON.errorMessage
        }
        self.shippingAddresses = []
        const result2 = await self.loadShippingData()
        self.isLoading = false
        self.$root.$children[0].$refs.toast.success("This address has been removed from your profile.", "Address Removed!")
      }catch(e){
        self.isLoading = false
        console.log(e)
        this.$root.$children[0].$refs.toast.error(e, "Error")
      }
    },

    async markAddressDefault(addressID){

      //update in FM
      var scriptParameters = {
        wholesalerID: this.userInfo.userID,
        shippingAddressID: addressID,
      }

      try{
        //update fm
        const result = await sharedAPI.runScript("Wholesale - Web Log - Set Default Address", JSON.stringify(scriptParameters))
        var resultJSON = JSON.parse(result.response.scriptResult)
        if (resultJSON.code != 0){
          throw resultJSON.errorMessage
        }

        //mark all credit cards are false
        this.shippingAddresses.forEach(address => {
          address.isDefault = false
        })

        //find index of cc card to make default
        var addressIndex = this.shippingAddresses.findIndex( address => address.__kptID == addressID)
        this.shippingAddresses[addressIndex].isDefault = true

      }catch(e){
        console.log(e)
        this.$root.$children[0].$refs.toast.error(e, "Error")
      }
    },

    addNewCC(){
      this.$router.replace({ name: 'paymentFormCustomer', params:{ id: this.userInfo.userID}, query: { from: this.$route.name }})
    },

    updateLocalAddress(address){
      var addressID = address.addressID
      console.log(address)
      if(addressID){
        //need to update existing record
        var arrayPosition = this.shippingAddresses.findIndex(singleAddress => singleAddress.__kptID == addressID);
        this.shippingAddresses[arrayPosition].name = address.address.name
        this.shippingAddresses[arrayPosition].shippingLine1 = address.address.shippingLine1
        this.shippingAddresses[arrayPosition].shippingLine2 = address.address.shippingLine2
        this.shippingAddresses[arrayPosition].shippingCity = address.address.shippingCity
        this.shippingAddresses[arrayPosition].shippingState = address.address.shippingState
        this.shippingAddresses[arrayPosition].shippingZip = address.address.shippingZip
        this.shippingAddresses[arrayPosition].shippingCountry = address.address.shippingCountry
      }else{
        //need to push new record if it's new
        this.shippingAddresses.push(address.address)
      }
    },

    cardModal(isNew, isUpdate, AddressID, address){
      this.$buefy.modal.open({
        props: {
          isNew: isNew,
          isUpdate: isUpdate,
          AddressID: AddressID,
          Address: address
        },
        parent: this,
        component: addressModal,
        hasModalCard: true,
        canCancel: false,
        events: {
          'update': address => {
            this.updateLocalAddress(address).then(this.loadShippingData())

          }
        }
      })
    },

  },
}
</script>

<style scoped>

.disabled{
  color: #fff;
  font-weight: 500;
  background: grey;
  width: 40px;
}.disabled::after{
  content: "x"
}
.disabled:hover{
  background: red;
  border: red;
  width: 80px;
}
.disabled:hover::after{
  content: "Remove?"
}
.newccbutton{
  padding: 0px 0px 15px 0px;
}

.warningText{
  color: red;
  padding-bottom: 15px;
}

button{
  padding: 10px;
  width: 150px;
  margin-left: 5px;
}

.buttonInteraction{
  height: 50px;
  display: flex;
  justify-content: flex-end;
}

.flexChild{
  flex: 0;

}

.userfooter{
  display: block;
  text-align: right;
}

.subHead{
  padding-bottom: 15px;
  color: gray;
}

.buttonColumn{
  display: block;
  text-align: right;
}

/* .update{
  margin: 5px 12px 5px 12px
} */

</style>